import { Checkbox, Col, Form, Input, InputNumber, Row, Statistic } from 'antd'
import useFetchSelect from 'elements/Hooks/useFetchSelect'
import { strVal } from '../../../../modules/Utils'
import CustomSpin from '../../../../elements/CustomSpin'
import DeliveryDetails from '../../../../elements/DeliveryDetails'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import InfoTooltip from '../../../../elements/InfoTooltip'
import ProductSelection from '../../../../elements/ProductSelection'
import CustomDebounceSelect from '../../../../elements/Select/CustomDebounceSelect'
import UOM from '../../../../elements/Select/UOM'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { get, isEmpty, set } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
  boolLabelItemLayout,
} from '../../../../modules/FormItems'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { compose } from 'recompose'
import MaterialDetails from '../../../../elements/MaterialDetails'
import ShippingDetails from '../../../../elements/ShippingDetails'

const { TextArea } = Input
const VendorSelect = compose(
  withUrlFetch({
    name: 'members',
    url: `members/list/organisation`,
  }),
  withSpinning
)(CustomDebounceSelect)

function RequisitionsLinesForm(props) {
  const { requisition, sales, line, list } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, getFieldsValue } = props.form

  console.log({ list })
  const Max = ('000' + (list.length + 1)).slice(-2)

  const budgetType = get(requisition, 'budget.budgetType')
  const toShip = getFieldValue('purchase.toShip')
  const toStock = getFieldValue('purchase.toStock')
  const fromStock = getFieldValue('purchase.fromStock') || get(requisition, 'orderType[1]') === 'Stock Release Order'

  const vendor = get(line, 'vendorQuoteLine.spquote.vendor')

  const [orderLine, setOrderLine] = useState({})

  const productID = get(orderLine, 'product._id', '').replace('products/', '')
  const { data: product, fetching: fetchingProduct } = useFetchURL(
    `foxxapi/products/${productID}`,
    [orderLine, productID],
    isEmpty(productID)
  )

  const productLineID = get(orderLine, 'productLine.name', '').replace('productsLines/', '')
  const { data: productLine, fetching: fetchingProductLines } = useFetchURL(
    `foxxapi/products/${productLineID}`,
    [orderLine, productLineID],
    isEmpty(productID)
  )

  const isStocked = get(product, 'isStocked', false)

  const vendorQuote =
    getFieldValue('vendorQuote._id') ||
    get(orderLine, 'vendorQuote._id') ||
    get(orderLine, 'vendorQuoteLine.spquote._id') ||
    ''

  const budgetKey = get(requisition, 'budget._key')
  const { SelectData: BudgetLinesSelect, selected: budgetLine } = useFetchSelect({
    url: `budgets/${budgetKey}/lines`,
    dependencyArray: [budgetKey],
  })

  const nominatedVendor = getFieldValue('nominatedVendor') || !!vendorQuote
  const unit = getFieldValue('unit') || 0
  const rate = getFieldValue('rate') || 0
  useEffect(() => {
    const max = unit * rate
    setFieldsValue({ max })
  }, [budgetLine, unit, rate])

  const salesKey = strVal(requisition, 'sales._id', '').replace('sales/', '')
  const [OrderLinesSelect] = useFetchSelectUrl(
    {
      name: 'OrderLinesSelect',
      url: `sales/${salesKey}/lines`,
      cache: true,
    },
    [salesKey]
  )

  const vendorID = getFieldValue('vendor._id') || ''
  const [VendorRepSelect] = useFetchSelectUrl(
    {
      name: 'vendorRep',
      url: `${vendorID}/representatives`,
    },
    [vendorID],
    isEmpty(vendorID)
  )

  const vendorQuotesURL = getFieldValue('nominatedVendor')
    ? `vendorQuotes/?owner=${vendorID.replace('members/', '')}&select=_id,title`
    : `vendorQuotes/?select=_id,title`

  const [VendorQuoteSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: vendorQuotesURL,
    },
    [getFieldValue('nominatedVendor'), vendorQuotesURL, vendorID]
  )

  const [VendorQuoteLinesSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: `vendorQuotes/lines/${vendorQuote.replace('spquotes/', '')}`,
    },
    [vendorQuote],
    isEmpty(vendorQuote)
  )

  useEffect(() => {
    setFieldsValue({ nominatedVendor: true })
  }, [vendorQuote])

  useEffect(() => {
    const vq =
      get(line, 'vendorQuote._id') || get(orderLine, 'vendorQuote._id') || get(orderLine, 'vendorQuoteLine.spquote._id')

    const vql = get(line, 'vendorQuoteLine._id') || get(orderLine, 'vendorQuoteLine._id')

    const vendor = get(line, 'vendor._id') || get(orderLine, 'vendorQuoteLine.spquote.vendor._id')

    const vendorRep = get(line, 'vendorRep._id') || get(orderLine, 'vendorQuoteLine.spquote.vendorRep._id')

    console.log({ line, orderLine })
    setFieldsValue({
      nominatedVendor: true,
      'vendorQuoteLine._id': vql,
      'vendorQuote._id': vq,
      'vendorRep._id': vendorRep,
      'vendor._id': vendor,
      'uom.code': get(orderLine, 'uom.code') || get(line, 'uom.code'),
      rate: get(orderLine, 'rate') || get(line, 'vendorQuoteLine.rate') || get(line, 'rate'),
      description: get(orderLine, 'description') || get(line, 'description'),
      unit: get(orderLine, 'unit') || get(line, 'unit'),
      no: get(orderLine, 'no') || get(line, 'no') || Max,
      name: get(orderLine, 'name') || get(line, 'name'),
    })
  }, [getFieldValue('orderLine._id')])

  useEffect(() => {
    setFieldsValue({
      description: get(budgetLine, 'notes') || get(line, 'description'),
      name: get(budgetLine, 'name') || get(line, 'name'),
    })
  }, [getFieldValue('budgetLine._id')])

  const productLineKey = get(orderLine, 'productLine._id', '').replace('productsLines/', '')
  const { data: inventoryList } = useFetchURL(
    `foxxapi/inventory?select=*&productsLines=${productLineKey}`,
    [productLineKey],
    isEmpty(productLineKey)
  )

  let onSold = '_'
  let onOrder = '_'
  let currentInventory = '_'

  useEffect(() => {
    onOrder = inventoryList.reduce((acc, v) => acc + (v.onOrder || 0), 0)
    onSold = inventoryList.reduce((acc, v) => acc + (v.onSell || 0), 0)
    const sold = inventoryList.filter((i) => i.type === 'debit').reduce((acc, v) => acc + v.unit, 0)
    const bought = inventoryList.filter((i) => i.type === 'credit').reduce((acc, v) => acc + v.unit, 0)
    currentInventory = bought - sold
  }, [inventoryList])

  console.log({ line })

  return (
    <Form>
      <Row>
        <Row>
          {get(requisition, 'budget.budgetType') !== 'Internal' && (
            <Col span={12}>
              <Form.Item
                {...defaultFormItemLayout}
                label={
                  <InfoTooltip
                    value={'Sales Order Line'}
                    title={'Sales Order Line that this requisition relates to.'}
                  />
                }>
                {getFieldDecorator('orderLine._id', {
                  initialValue: get(line, 'orderLine._id'),
                })(<OrderLinesSelect setSelected={setOrderLine} keyAtr={'_id'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={<InfoTooltip value={'Budget Line'} title={'Specific Budget Line that this item relates to'} />}>
              {getFieldDecorator('budgetLine._id', {
                initialValue: get(line, 'budgetLine._id'),
                rules: rules.input,
              })(<BudgetLinesSelect data-testid="budgetLine._id" keyAtr={'_id'} valueAtr={'name'} />)}
            </Form.Item>
          </Col>
        </Row>

        {isStocked && (
          <Row style={{ background: 'rgba(4,110,154,0.33)', padding: 10 }}>
            <CustomSpin spinning={fetchingProduct || fetchingProductLines}>
              <FormSectionTitle title="Product Stock Status" padding={5} />
              <Row gutter={16}>
                <Col span={12}>
                  <Statistic
                    valueStyle={{ fontSize: 16 }}
                    title="Product"
                    value={`${get(product, 'code', '')}-${get(product, 'name', '')}`}
                  />
                </Col>
                <Col span={12}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="SKU" value={get(productLine, 'name')} />{' '}
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="Category" value={get(product, 'category.name')} />
                </Col>
                <Col span={12}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="Group" value={get(product, 'group.name')} />
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="onSell" value={onSold} />
                </Col>
                <Col span={8}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="onOrder" value={onOrder} />
                </Col>
                <Col span={8}>
                  <Statistic valueStyle={{ fontSize: 16 }} title="Current Inventory" value={currentInventory} />
                </Col>
              </Row>
            </CustomSpin>
          </Row>
        )}

        {!isStocked && (
          <>
            <Col span={24}>
              <Form.Item {...threeFormItemLayout} label={'NOMINATED VENDOR'}>
                {getFieldDecorator('nominatedVendor', {
                  initialValue: get(line, 'nominatedVendor') || !!vendor || get(orderLine, 'vendor._id'),
                  valuePropName: 'checked',
                })(<Checkbox placeholder={'NOMINATED VENDOR'} />)}
              </Form.Item>
            </Col>

            {nominatedVendor && (
              <>
                <FormSectionTitle title={'NOMINATED VENDOR DETAILS'} />
                <Row style={{ backgroundColor: '#dee2ff' }}>
                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label={'Vendor'}>
                      {getFieldDecorator('vendor._id', {
                        initialValue: get(line, 'vendor._id'),
                      })(
                        <VendorSelect
                          keyAtr={'_id'}
                          valueAtr={'fn'}
                          placeholder="Select a Vendor Quote"
                          onChange={(e) => {
                            resetFields(['vendorQuoteLine._id', 'vendorQuote._id'])
                            set(line, 'vendorQuoteLine._id', '')
                            set(line, 'vendorQuote._id', '')
                          }}
                          style={{ width: '100%' }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label={'Vendor Rep'}>
                      {getFieldDecorator('vendorRep._id', {
                        initialValue: get(line, 'vendorRep._id'),
                      })(
                        <VendorRepSelect
                          keyAtr={'_id'}
                          valueAtr={'name'}
                          placeholder="Select a Vendor Quote Line"
                          style={{ width: '100%' }}
                        />
                      )}
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label={'Vendor Quote'}>
                      {getFieldDecorator('vendorQuote._id', {
                        initialValue: get(line, 'vendorQuote._id'),
                      })(
                        <VendorQuoteSelect
                          keyAtr={'_id'}
                          valueAtr={'title'}
                          placeholder="Select a Vendor Quote"
                          style={{ width: '100%' }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...defaultFormItemLayout} label={'Vendor Quote Line'}>
                      {getFieldDecorator('vendorQuoteLine._id', {
                        initialValue: get(line, 'vendorQuoteLine._id'),
                      })(
                        <VendorQuoteLinesSelect
                          keyAtr={'_id'}
                          valueAtr={'name'}
                          placeholder="Select a Vendor Quote Line"
                          style={{ width: '100%' }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Row>

      <Row>
        <FormSectionTitle title={'Requisition Details'} />
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item {...defaultFormItemLayout} label={'Line No.'}>
              {getFieldDecorator('no', {
                initialValue: get(line, 'no') || Max,
                rules: [{ required: true, message: 'Please Select a No!' }],
              })(<Input placeholder={'Line No'} style={{ width: '80%' }} />)}
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item {...defaultFormItemLayout} label={'Line Name'}>
              {getFieldDecorator('name', {
                initialValue: get(line, 'name'),
                rules: rules.input,
              })(<Input placeholder={'Line Name'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Row>

      <Row>
        <Col span={16}>
          <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
            {getFieldDecorator('description', {
              initialValue: get(line, 'description'),
            })(<TextArea placeholder={'Description'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Unit'}>
            {getFieldDecorator('unit', {
              initialValue: get(line, 'unit'),
              rules: rules.input,
            })(<InputNumber data-testid="unit" style={{ width: '100%' }} placeholder={'Unit'} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'UoM'}>
            {getFieldDecorator('uom.code', {
              initialValue: get(line, 'uom.code'),
              rules: rules.select,
            })(<UOM />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'Rate'}>
            {getFieldDecorator('rate', {
              initialValue: get(line, 'rate'),
            })(<InputNumber style={{ width: '100%' }} placeholder={'Rate'} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Max Value'}>
            {getFieldDecorator('max', {
              initialValue: get(line, 'max'),
              rules: rules.input,
            })(<InputNumber style={{ width: '100%' }} placeholder={'Max Amount'} data-testid={'max'} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label={'ESTIMATE'}>
            {getFieldDecorator('isEstimate', {
              initialValue: get(line, 'isEstimate'),
              valuePropName: 'checked',
            })(<Checkbox data-testid="isEstimate" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item
            {...boolLabelItemLayout}
            label={
              <InfoTooltip
                value={'SUB-COMPONENT'}
                title={"If this component shouldn't count in against sales order line quantity."}
              />
            }>
            {getFieldDecorator('isSubcomponents', {
              initialValue: get(line, 'isSubcomponents'),
              valuePropName: 'checked',
            })(<Checkbox data-testid="isSubcomponent" />)}
          </Form.Item>
        </Col>

        {budgetType === 'Internal' && (
          <Col span={16}>
            <Form.Item {...defaultFormItemLayout} label={'TO SHIP'}>
              {getFieldDecorator('purchase.toShip', {
                initialValue: get(line, 'purchase.toShip'),
                valuePropName: 'checked',
              })(<Checkbox placeholder={'To Ship'} />)}
            </Form.Item>
          </Col>
        )}

        {budgetType === 'Internal' && (
          <Col span={16}>
            <Form.Item {...defaultFormItemLayout} label={'TO Stock'}>
              {getFieldDecorator('purchase.toStock', {
                initialValue: get(line, 'purchase.toStock'),
                valuePropName: 'checked',
              })(<Checkbox placeholder={'To Stock'} />)}
            </Form.Item>
          </Col>
        )}

        {budgetType !== 'Internal' && (
          <>
            <Col span={8}>
              <Form.Item {...boolLabelItemLayout} label={'INTERNAL SHIPPING'}>
                {getFieldDecorator('purchase.toShip', {
                  initialValue: get(line, 'purchase.toShip'),
                  valuePropName: 'checked',
                })(<Checkbox placeholder={'Requires Internal Shipping'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...boolLabelItemLayout} label={'FROM STOCK'}>
                {getFieldDecorator('purchase.fromStock', {
                  initialValue: fromStock,
                  valuePropName: 'checked',
                })(<Checkbox disabled placeholder={'From Stock'} />)}
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
      {toShip && (
        <Row>
          <DeliveryDetails
            title={'INTERNAL DELIVERY REQUIREMENTS'}
            doc={line}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'RequisitionsInternalDO',
              prefix: 'delivery.deliveryOrder',
            }}
          />
        </Row>
      )}

      {toStock && (
        <Row>
          <ProductSelection
            doc={line}
            {...{
              getFieldDecorator,
              getFieldsValue,
              getFieldValue,
              setFieldsValue,
              resetFields,
              company: get(requisition, 'company._id'),
            }}
          />
        </Row>
      )}

      <FormSectionTitle title={'ORDERING INSTRUCTIONS'} />
      <Row>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label={'Instruction'}>
            {getFieldDecorator('purchase.instruction', {
              initialValue: get(line, 'purchase.instruction'),
            })(<TextArea placeholder={'Purchase Instructions'} />)}
          </Form.Item>
        </Col>
      </Row>

      {/*NOMINATED VENDOR*/}

      {requisition.type === 'Purchase' && (
        <>
          {/*MATERIAL DETAILS*/}
          <MaterialDetails
            line={{
              ...line,
              materials: {
                ...get(orderLine, 'materials'),
                ...get(line, 'materials'),
              },
            }}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
            }}
          />
          {/*SHIPPING DETAILS*/}
          <ShippingDetails
            line={{
              ...line,
              shipping: {
                ...get(orderLine, 'shipping'),
                ...get(line, 'shipping'),
              },
            }}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'Purchase',
            }}
          />

          <Row>
            <DeliveryDetails
              doc={{
                ...line,
                delivery: {
                  ...get(orderLine, 'delivery'),
                  ...get(sales, 'delivery'),
                  ...get(line, 'delivery'),
                },
              }}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'RequisitionsLinesForm',
              }}
            />
          </Row>
        </>
      )}

      {/*{requisition.type === 'Freight' && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Freight Type'}>
              {getFieldDecorator('freight.type', {
                initialValue: get(line, 'freight.type'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.type"
                  placeholder={'Freight Type'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Freight Method'}>
              {getFieldDecorator('freight.method', {
                initialValue: get(line, 'freight.method'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.method"
                  placeholder={'Freight Method'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Freight Notify Rep'}>
              {getFieldDecorator('freight.notifyRep', {
                initialValue: get(line, 'freight.notifyRep'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.notifyRep"
                  placeholder={'Freight Notify Rep'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={'two-rows-label'}
              {...defaultFormItemLayout}
              label={'Freight Shipping Address'}>
              {getFieldDecorator('freight.shippingAddress', {
                initialValue: get(line, 'freight.shippingAddress'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.shippingAddress"
                  placeholder={'Freight Shipping Address'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={'two-rows-label'}
              {...defaultFormItemLayout}
              label={'Freight Final Destination'}>
              {getFieldDecorator('freight.finalDestination', {
                initialValue: get(line, 'freight.finalDestination'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.finalDestination"
                  placeholder={'Freight Final Destination'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={'two-rows-label'}
              {...defaultFormItemLayout}
              label={'Freight Instructions Shipper'}>
              {getFieldDecorator('freight.instructions.shipper', {
                initialValue: get(line, 'freight.instructions.shipper'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.instructions.shipper"
                  placeholder={'Freight Instructions shipper'}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={'two-rows-label'}
              {...defaultFormItemLayout}
              label={'Freight Instructions packing'}>
              {getFieldDecorator('freight.instructions.packing', {
                initialValue: get(line, 'freight.instructions.packing'),
                rules: rules.input,
              })(
                <Input
                  data-testid="freight.instructions.packing"
                  placeholder={'Freight Instructions packing'}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
      )}*/}
      {/*{requisition.type === 'Labour' && <Row />}*/}
    </Form>
  )
}

RequisitionsLinesForm.propTypes = {}
RequisitionsLinesForm.defaultProps = {}

export default Form.create()(RequisitionsLinesForm)
